import { forwardRef } from "react";
import { Button as UiButton, type UiButtonProps } from "@wombat/ui-kit";
import { Babel } from "../Language";

export type MyButtonProps = UiButtonProps & {
  translate?: boolean;
};

const renderButtonChildren = (
  children: React.ReactNode,
  translate: boolean,
): React.ReactNode => {
  if (translate && typeof children === "string" && children.length > 0) {
    return <Babel>{children}</Babel>;
  }

  return children;
};

export default forwardRef<HTMLButtonElement, MyButtonProps>(function MyButton(
  { children, translate = true, ...rest },
  ref,
) {
  return (
    <UiButton ref={ref} {...rest}>
      {renderButtonChildren(children, translate)}
    </UiButton>
  );
});
